module.exports = __webpack_public_path__ + "img/dashboardWhite.3b356727.png";